module.exports = __webpack_public_path__ + "img/np.99f3f926.jpg";